import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/coaching-business")({
  staticData: { title: "Coaching Business" },
  component: () => <Outlet />,
});
